import React, { useEffect, useState } from 'react'
import { Theme, Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { Tab } from './NetworkContentTabs'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { SocialNetworkLicensePermissions } from '@professocial/professocialTypes/types/commonTypes'

interface ITabsProps {
  activeItem?: NetworkType
  tabs: Tab[]
  onChangeTab?: (key: NetworkType) => void
  licensePermissions?: SocialNetworkLicensePermissions
}

const useStyles = makeStyles((theme: Theme) => ({
  tabMenuMargin: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  subMenu: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1, 4),
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  subMenuText: {
    whiteSpace: 'nowrap',
    fontSize: '15px',
    height: '20px',
    fontFamily: theme.typography.fontFamily,
  },
  activeItem: {
    borderBottom: `3px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '& svg': {
      fill: theme.palette.primary.main,
    },
  },
  disabled: {
    color: theme.palette.text.disabled,
    pointerEvents: 'none',
    '& svg': {
      fill: theme.palette.text.disabled,
    },
  },
  inactiveItem: {
    color: theme.palette.text.primary,
    '&:hover': {
      borderBottom: `3px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      '& svg': {
        fill: theme.palette.primary.main,
      },
    },
  },
}))

const TabMenu: React.FC<ITabsProps> = (props) => {
  const classes = useStyles()
  const [activeItem, setActiveItem] = useState<NetworkType>()

  useEffect(() => {
    setActiveItem(props.activeItem)
  }, [props.activeItem])

  return (
    <Grid container spacing={1} className={classes.tabMenuMargin}>
      {props.tabs.map((tab: Tab, index) => {
        const setClassStatus = activeItem === tab.name ? classes.activeItem : tab.disabled ? classes.disabled : classes.inactiveItem
        return (
          <Grid key={index} item>
            <div
              className={`${classes.subMenu} ${setClassStatus}`}
              onClick={() => {
                props.onChangeTab && props.onChangeTab(tab.name)
              }}
            >
              {tab.icon}
              <Typography className={classes.subMenuText}>{tab.label}</Typography>
            </div>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default TabMenu
